import React from 'react'

const ContactUs = () => {
  return (
    <h1>This is the Contact Us</h1>
  )
}

export default ContactUs